<mat-form-field (click)="input.click()">
    <mat-icon matPrefix>upload</mat-icon>
    <mat-label>{{label}}</mat-label>
    <input matInput [disabled]="true" [ngModel]="fileName">
</mat-form-field>
<input #input type="file" accept="image/png, image/jpeg" (change)="changeFile($event)">